import { Component, input } from '@angular/core';
import { AlbionImageService } from 'src/app/services/albion-image/albion-image.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Item } from '../../models/items.model';

@Component({
  selector: 'app-item-image',
  imports: [MatTooltipModule],
  templateUrl: './item-image.component.html',
  styleUrl: './item-image.component.scss',
})
export class ItemImageComponent {
  item = input.required<Item>();
  quality = input<number>();
  size = input<number>();
  hideTooltip = input<boolean>(false);

  imageLoaded = false;

  constructor(public albionImageService: AlbionImageService) {}
}
